// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Mundial2026",
    title: "Mundial 2026 ⚽",
    version: "1.0.0",
    tablePrefix: "gen",
    entryPoint: "EntradaApp",
    loginCollection: "LoginColl",
    autoLogon: false,
    apiBase: "/api/v1",
    defaultLanguage: "javascript",
} as const;
